export default __webpack_public_path__ + "static/media/prev-elevatepro.650a148e.jpg";